import { useMemo, useState } from "react";

import { DashboardContext } from "./dashboard-context";

export function DashboardProvider({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  const [selectedDashboardId, setSelectedDashboardId] = useState<string | null>(
    null,
  );

  const contextValue = useMemo(
    () => ({ selectedDashboardId, setSelectedDashboardId }),
    [selectedDashboardId],
  );

  return (
    <DashboardContext.Provider value={contextValue}>
      {children}
    </DashboardContext.Provider>
  );
}
